import React from "react"
import {
  DisplayTableWrapper,
  TableBody,
  DisplayTableCell,
  DisplayTableHead,
  DisplayTableHeaderCell,
  DisplayTableRow,
  DisplayTableFooter,
  DisplayTableFooterRow,
  DisplayTableFooterCell,
} from "../../styles"
import PropTypes from "prop-types"

function DisplayTable({ headers, rows, footers, id, style }) {
  return (
    <DisplayTableWrapper id={id} subStyle={style}>
      {headers && (
        <DisplayTableHead>
          <DisplayTableRow>
            <DisplayTableHeaderCell isEmpty={true} />
            {headers.map((header, i) => (
              <DisplayTableHeaderCell key={`header-${header}-cell-${i}`} type="column">
                {header}
              </DisplayTableHeaderCell>
            ))}
          </DisplayTableRow>
        </DisplayTableHead>
      )}
      <TableBody>
        {rows.map((row, index) => (
          <DisplayTableRow key={`row-${row.label}-cell-${index}`}>
            <DisplayTableHeaderCell>{row.label}</DisplayTableHeaderCell>
            {row.cells.map((cell, i) => (
              <DisplayTableCell key={`row-${row.label}-cell-${i}`} subStyle={style}>
                {cell}
              </DisplayTableCell>
            ))}
          </DisplayTableRow>
        ))}
      </TableBody>
      {footers && (
        <DisplayTableFooter>
          {footers.map((row, i) => (
            <React.Fragment key={`table-${id}-footers-${i}`}>
              {/** add a blank footers row between rows if there is more than 1 footers row, for spacing */}
              {i > 0 && <DisplayTableFooterRow data-testid={"footers-row"} />}
              <DisplayTableFooterRow data-testid={"footers-row"}>
                <DisplayTableHeaderCell>{row.label}</DisplayTableHeaderCell>
                {row.cells.map((cell, i) => (
                  <DisplayTableFooterCell key={`footers-cell-${i}`}>
                    {cell}
                  </DisplayTableFooterCell>
                ))}
              </DisplayTableFooterRow>
            </React.Fragment>
          ))}
        </DisplayTableFooter>
      )}
    </DisplayTableWrapper>
  )
}

DisplayTable.propTypes = {
  /** Headers for the table */
  headers: PropTypes.arrayOf(PropTypes.string),
  /** Rows for the table */
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      /** The row header */
      label: PropTypes.string,
      /** Array of cells that should contain the display value for the cell */
      cells: PropTypes.arrayOf(PropTypes.any),
    })
  ),
  /** Footer rows for the table, if required */
  footers: PropTypes.arrayOf(
    PropTypes.shape({
      /** The footers row header */
      label: PropTypes.string,
      /** Array of cells that should contain the display value for the cell */
      cells: PropTypes.arrayOf(PropTypes.any),
    })
  ),
}

export default DisplayTable
